import React from "react";
import ResultsList from "./ResultsList";
import styled from "styled-components";


const ResultsContainer = styled.div`
  border: 1px solid black;
  width: ${(props) => (props.width ? props.width : "300px")};
  margin: auto;
  position: absolute;
  background-color: white;
  z-index: 99;
`;

export default function SearchResults({ visible, results, template, width , onItemClick}) {
  return (
    <>
      {visible ? (
        <ResultsContainer width={width}>
          {results!==null && results!== undefined && results.length > 0 ?
          <ResultsList items={results} template={template} onClickCallback={onItemClick}/> :
          <p>No results found</p>}
          {/* <button>Show more results...</button> */}
        </ResultsContainer>
      ) : null}
    </>
  );
}


